<template>
    <div class="messagecenter">
      <div class="messagecenter-headline">
          <span >{{ $t('translateText.Notes.bj') }}</span>
          <a-icon type="right" style="margin:0 10px" />
          <span style="color:black" >{{$t('translateText.Notes.xbj')}}</span>
      </div>
      <div class="course">
          <p>{{$t('translateText.Notes.sskc')}}</p>
          <a-select
            class="combobox"
            v-model="course"
            default-value="请选择"
        >
            <a-select-option
                v-for="(item) in courses"
                :key="item.course.iCourseId"
            >
                {{ item.course.strCourseName}}
            </a-select-option>
          </a-select> 
      </div>
      <div class="notename">
          <p>{{$t('translateText.Notes.bjmc')}}</p>
            <a-input
              style=" letter-spacing: 2px;"
              placeholder=""
              v-model="noteName"
          >{{}}</a-input>
      </div>
      <div class="notecontent">
          <p>{{$t('translateText.Notes.bjnr')}}</p>
           <textarea
              class="note-content"
              placeholder=""
              v-model="notecont"
          ></textarea>
      </div>
      <div class="but">
          <one-button @click="revocation">{{$t('translateText.Notes.fh')}}</one-button>
          <one-button @click="save">{{$t('translateText.Notes.qd')}}</one-button>
      </div>
    </div>
</template>
<script>
import { AddNote,UpdateNote,getUserCourse } from "@/utils/api";
export default {
  data() {
    return {
        iCourseId:0,
        noteName: "", //课程名称
        notecont:"",// 笔记内容
        course:"",
        courses:[],
        defaultval:"请选择"
    };
  },
  props:{
    itemlll:Object,
    },
  methods: {
      revocation(){
        this.noteName = "";
        this.notecont="",
          // this.$router.push("/StudentNote")
          this.$router.go(-1);
          this.$parent.GetNotes()
      },
         save() {
          this.userinfo = this.$store.state.userinfo
            if (
                // this.$parent.isadd=true,
                this.noteName == "" ||
                this.notecont == ""
            ) {
                this.$message.error(this.$t("translateText.addCourse.pleaseComplete"));
            } else {
                  if(this.$parent.isadd){
                    AddNote({
                        user:{
                          iUserId:this.userinfo.iUserId,
                          // iUserId:"1",
                        },
                        course:{
                          iCourseId:this.course,
                        },
                        courseFile:{
                          iCourseFileId : 0,
                          },
                        strNoteName:this.noteName,
                        strNoteContent:this.notecont,
                    }).then((response)=>{
                        if(response.data.iCode == 0){
                          this.$parent.CourseName=''
                          this.$parent.GetNotes()
                            this.$emit("checkedArr",response.data.objData)
                            this.$router.push("/StudentNote")  
                       }else{
                            return this.$message.error(response.data.strMessage);
                       }
                    });

                  }else{
                          UpdateNote({
                              user:{
                                      iUserId:this.userinfo.iUserId,
                                    },
                                    course:{
                                      iCourseId:this.course,
                                    },
                                    iNoteId:this.itemlll.iNoteId,
                                    strNoteName:this.noteName,
                                    strNoteContent:this.notecont,
                            }).then((response)=>{
                               if(response.data.iCode == 0){
                               this.$parent.GetNotes()
                               this.$router.push("/StudentNote")  
                       }else{
                            return this.$message.error(response.data.strMessage);
                             }
                            })
                  }
            }
        },
 
  },
  mounted(){
    this.userinfo = this.$store.state.userinfo;
    if(this.$parent.isadd){
      this.noteName='',
      this.notecont=""
    }else{
      this.noteName=this.itemlll.strNoteName
      this.notecont=this.itemlll.strNoteContent
      this.course = this.itemlll.course.iCourseId
    }
    getUserCourse({
      iUserId: this.userinfo.iUserId,
      timequantum :true,
      iRoleId:this.userinfo.role.iRoleId
    }).then((response) => {
      if (response.data.iCode == 0) {
        
        this.courses = response.data.objData
        // this.courses.map((item)=>{
        //   if(item.course.iCourseId == this.itemlll.course.iCourseId){
        //     isoverdue = false
        //   }
        // })
        // if(!this.$parent.isadd && isoverdue){
        //   this.courses.push({course:this.itemlll.course})
        // }
        if(!this.$parent.isadd){
          let isoverdue = true
          this.courses.map((item)=>{
            if(item.course.iCourseId == this.itemlll.course.iCourseId){
              isoverdue = false
            }
          })
          if(isoverdue){
            this.courses.push({course:this.itemlll.course})
          }
        }
      } else {
        return this.$message.error(response.data.strMessage);
      }
    });  
  },
  components: {
  },

}
</script>
<style lang="stylus" scoped>
.note-content{
  padding:10px;
  line-height 1.5
  letter-spacing: 2px;
}
.messagecenter 
  width: 100%;
  height: 100%;
  background-color: white;
  position relative
  & span 
    font-weight: 700;
    font-size 16px
.messagecenter-headline {
  width: 87%;
  height: 10%;
  margin-left 2%
  border-bottom: 2px solid #dadada;
  display flex
  justify-content: flex-start 
  align-items center
  @media (max-width: 1025px) {
    height: 12%;
  }

  @media (max-width: 500px) {
    height: 15%;
  }
}
.course
    width 100%
    height 10%
    margin-left 2%
    display flex
    justify-content: flex-start 
    align-items center
    & p
        margin-right 2%
        width: 100px
        font-size 14px
        font-weight  700
.combobox
    width 20%
.notename
    width 100%
    height 10%
    margin-left 2%
    display flex
    justify-content: flex-start 
    align-items center
    & p
        margin-right 2%
        width: 100px
        font-size 14px
        font-weight  700
    & input 
        width 80%
        height 50%
        outline none 
        border 1px solid #dadada
.notecontent
    width 100%
    height 60%
    margin-left 2%
    display flex
    justify-content: flex-start 
    // align-items center
    & p
        margin-top 1%
        margin-right 2%
        width: 100px
        font-size 14px
        font-weight  700
    & textarea 
        width 80%
        height 100%  !important
        border 1px solid #dadada
        outline: none;
        resize: none;
.but
    width 50%
    margin-left 25%
    height 10%
    display flex
    justify-content: space-around;
    align-items center
/deep/.ant-select-selection:hover{
  border-color:#dadada !important;
  border-right-width: 1px !important;
  color #333333 !important;
}
/deep/.ant-select-focused{
  border-color #dadada !important;
  box-shadow 0 0 0 0 !important;
  color #333333 !important;
}
/deep/.ant-select-selection{
  border-color #dadada  !important;
  box-shadow 0 0 0 0 !important;
  color #333333 !important;
}
</style>